import { render, staticRenderFns } from "./CurrentResidenceType.vue?vue&type=template&id=462339d4&"
import script from "./CurrentResidenceType.vue?vue&type=script&lang=js&"
export * from "./CurrentResidenceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports